module.exports = __webpack_public_path__ + "assets/img/duck-2.80e4524c.jpeg";